module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg30.665c5011.jpg";